import moment from 'moment';
import { CompteEntity } from '../../../../entities/compte.entity';
import { GrandLivreEntity } from '../../../../entities/grandLivre.entity';
import {
  ExportFormat,
  ExportMetadata,
  exportPremiumFile,
} from '../../../../shared/exportFiles';

export const generateGLToExport = (GL: GrandLivreEntity[]) => {
  let toExport: any[] = [];
  let index = 1;
  for (let gl of GL) {
    toExport.push({
      Index: index,
      'Numero Compte': gl.num_compte,
      'Intitulé Compte': gl.intitule_compte,
      'Date saisi': gl.date_saisi,
      'Date document': gl.date_document,
      Document: gl.document,
      'Pièce comptable': gl.piece,
      'Libellé transaction': gl.libelle,
      'Catégorie titre': gl.categorie_titre,
      Emetteur: gl.tresor_emetteur,
      Titulaire: gl.titulaire,
      Crédit: gl.credit,
      Débit: gl.debit,
      Solde: gl.solde,
      'Actif (O/N)': gl.actif,
      Type: gl.type,
      'Utilisateur saisi': gl.utilisateur_saisi?.split('/')[5] || '',
      'Utilisateur validé': gl.utilisateur_valide?.split('/')[5] || '',
      'Date création': `${moment(gl.created_at).format('DD/MM/YYYY HH:mm:ss')}`,
      'Date modification': `${moment(gl.updated_at).format(
        'DD/MM/YYYY HH:mm:ss',
      )}`,
    });
    index += 1;
  }

  return toExport;
};

export const exportGLData = (
  GL: GrandLivreEntity[],
  format: ExportFormat,
  metadata?: ExportMetadata,
) => {
  const glData = generateGLToExport(GL);

  exportPremiumFile({
    fileName: 'Grand livre',
    metadata,
    title: 'Grand livre',
    sheets: [{ data: glData, name: 'Grand livre' }],
  }, format);
};

export const generateCompteToExport = (comptes: CompteEntity[]) => {
  let toExport: any[] = [];
  let index = 1;
  for (let cpt of comptes) {
    toExport.push({
      Index: index,
      'Code chapitre': cpt.code_chapitre,
      'Code titre': cpt.code_titre,
      'Code SVT': cpt.code_svt,
      'Code client': cpt.code_client,
      'Code agence': cpt.code_agence,
      'Numero Compte': cpt.num_compte,
      'Intitulé Compte': cpt.intitule,
      Crédit: cpt.credit,
      Débit: cpt.debit,
      Solde: cpt.solde,
      'Date dernier crédit': cpt.date_dernier_credit
        ? `${moment(cpt.date_dernier_credit).format('DD/MM/YYYY HH:mm:ss')}`
        : '',
      'Date dernier dédit': cpt.date_dernier_debit
        ? `${moment(cpt.date_dernier_debit).format('DD/MM/YYYY HH:mm:ss')}`
        : '',
      'Statut (O/N)': cpt.statut,
      'Date création': `${moment(cpt.created_at).format(
        'DD/MM/YYYY HH:mm:ss',
      )}`,
      'Date modification': `${moment(cpt.updated_at).format(
        'DD/MM/YYYY HH:mm:ss',
      )}`,
    });
    index += 1;
  }

  return toExport;
};

export const exportCompteData = (
  comptes: CompteEntity[],
  format: ExportFormat,
  metadata?: ExportMetadata,
) => {
  const compteData = generateCompteToExport(comptes);

  exportPremiumFile({
    fileName: 'Comptes',
    metadata,
    title: 'Comptes',
    sheets: [{ data: compteData, name: 'Comptes' }],
  }, format);
};

export const exportBGData = (
  BG: any,
  format: ExportFormat,
  metadata?: ExportMetadata,
) => {
  exportPremiumFile({
    fileName: 'Balance generale',
    metadata,
    title: 'Balance generale',
    sheets: [
      { data: generateBalanceRows(BG?.globale || [], 'intitule_compte', 'Intitulé compte'), name: 'BG generale' },
      { data: generateBalanceRows(BG?.titre || [], 'categorie_titre', 'Titre'), name: 'BG par titre' },
      { data: generateBalanceRows(BG?.tresor || [], 'tresor_emetteur', 'Trésor émetteur'), name: 'BG par tresor' },
      { data: generateBalanceRows(BG?.titulaire || [], 'titulaire', 'Titulaire'), name: 'BG par titulaire' },
    ],
  }, format);
};

const generateBalanceRows = (
  rows: any[],
  labelKey: string,
  labelName: string,
) =>
  rows.map((row, index) => ({
    Index: index + 1,
    [labelName]: row[labelKey],
    'Cumul crédit': row.sum_credit,
    'Cumul débit': row.sum_debit,
    Solde: row.sum_solde,
    'Contrôle débit/crédit':
      Number(row.sum_credit || 0) === Number(row.sum_debit || 0)
        ? 'Équilibré'
        : 'Écart',
  }));
